import { gql } from '@web/federation/gql'

export const BookingNotificationSectionQuery = gql(`
  query BookingNotificationSection {
    bookingNotificationsCount
  }
`)
